import { SET_TASKS_DOWNLOAD_RECORD } from '../constants/TaskRecordConstants';

const initialState = {
  taskDownloadRecords: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TASKS_DOWNLOAD_RECORD: {
      return {
        ...state,
        taskDownloadRecords: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
